import { CheckCircle2, XCircle, UserCog, UserPlus, Briefcase, Send, Inbox, Store, Upload, FileText, Trash2, Activity } from "lucide-react";

const ACT = {
  "provider.approve": { icon: CheckCircle2, color: "#10b981" },
  "provider.reject": { icon: XCircle, color: "#f43f5e" },
  "provider.create": { icon: Store, color: "#a1a1aa" },
  "membership.update": { icon: UserCog, color: "#3b82f6" },
  "job.create": { icon: Briefcase, color: "#a1a1aa" },
  "job.approve": { icon: CheckCircle2, color: "#10b981" },
  "application.create": { icon: Send, color: "#3b82f6" },
  "candidate.upsert": { icon: UserPlus, color: "#8b5cf6" },
  "inquiry.create": { icon: Inbox, color: "#3b82f6" },
  "inquiry.status": { icon: Inbox, color: "#a1a1aa" },
  "document.upload": { icon: Upload, color: "#3b82f6" },
  "document.update": { icon: FileText, color: "#a1a1aa" },
  "document.delete": { icon: Trash2, color: "#f43f5e" },
};

function timeAgo(iso) {
  try {
    const d = new Date(iso);
    const diff = (Date.now() - d.getTime()) / 1000;
    if (diff < 60) return "gerade eben";
    if (diff < 3600) return `vor ${Math.floor(diff / 60)} Min`;
    if (diff < 86400) return `vor ${Math.floor(diff / 3600)} Std`;
    return d.toLocaleDateString("de-CH");
  } catch {
    return "";
  }
}

export function ActivityTimeline({ items = [], t, compact }) {
  return (
    <div
      data-testid="control-activity-timeline"
      className="flex h-full flex-col rounded-xl border border-zinc-800 bg-zinc-900 p-5"
    >
      <div className="mb-4 flex items-center justify-between border-b border-zinc-800/60 pb-4">
        <h3 className="flex items-center gap-2 font-heading text-base font-bold text-white">
          <Activity className="h-4 w-4 text-zinc-400" />
          {t("control.recentActivity")}
        </h3>
      </div>

      {items.length === 0 ? (
        <div className="py-8 text-center text-sm text-zinc-500" data-testid="activity-empty">{t("act.empty")}</div>
      ) : (
        <div className="relative flex flex-col">
          <span className="absolute bottom-2 left-[15px] top-2 w-px bg-zinc-800" />
          {(compact ? items.slice(0, 6) : items).map((a) => {
            const meta = ACT[a.action] || { icon: Activity, color: "#a1a1aa" };
            const Icon = meta.icon;
            return (
              <div key={a.id} className="relative flex items-start gap-3 py-2.5" data-testid={`activity-${a.id}`}>
                <span
                  className="relative z-10 flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-zinc-700 bg-zinc-950"
                  style={{ color: meta.color }}
                >
                  <Icon className="h-3.5 w-3.5" />
                </span>
                <div className="min-w-0 flex-1 pt-1">
                  <div className="flex items-center gap-2">
                    <span className="truncate text-sm text-zinc-200">{t(`act.${a.action}`) !== `act.${a.action}` ? t(`act.${a.action}`) : a.action}</span>
                    <span className="rounded bg-zinc-800 px-1.5 py-0.5 text-[10px] font-medium uppercase tracking-wider text-zinc-400">{a.portal_key}</span>
                  </div>
                  <div className="mt-0.5 text-xs text-zinc-500">
                    {a.actor_name || "System"} · {timeAgo(a.created_at)}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
